/**
 * Generate SEO-friendly URLs for venues and experiences.
 */

export function generateSlug(name) {
  if (!name) return '';
  return name.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim();
}

export function venueUrl(venue) {
  if (!venue) return '/venues';
  const state = (venue.state || 'co').toLowerCase();
  const city = (venue.city || 'denver').toLowerCase().replace(/\s+/g, '-');
  const neighborhood = (venue.neighborhood || 'rino').toLowerCase();
  const slug = venue.slug || generateSlug(venue.name);
  return `/venues/${state}/${city}/${neighborhood}/${slug}`;
}

export function experienceUrl(experience, venue) {
  if (!experience) return '/experiences';
  const state = (venue?.state || experience?.state || 'co').toLowerCase();
  const city = (venue?.city || experience?.city || 'denver').toLowerCase().replace(/\s+/g, '-');
  const neighborhood = (venue?.neighborhood || experience?.neighborhood || 'rino').toLowerCase();
  const venueSlug = generateSlug(venue?.name || experience?.venue_name || 'venue');
  const slug = experience.slug || generateSlug(experience.title);
  return `/experiences/${state}/${city}/${neighborhood}/${venueSlug}/${slug}`;
}
